<template>
  <div
    v-if="src"
    class="absolute inset-0 overflow-hidden pointer-events-none"
    :style="{ opacity: opacity }"
  >
    <img
      v-if="isCustom"
      :src="src"
      class="absolute h-auto block select-none"
      :style="{ left: `${x}%`, top: `${y}%`, width: `${scale}%` }"
      draggable="false"
      alt=""
    />
    <div
      v-else
      class="absolute inset-0"
      :style="{
        backgroundImage: `url('${src}')`,
        backgroundSize: mode,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }"
    ></div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  src: { type: String, default: '' },
  adjust: { type: Object, default: null },
});

const mode = computed(() => props.adjust?.mode || 'cover');
const isCustom = computed(() => mode.value !== 'cover' && mode.value !== 'contain');
const opacity = computed(() => {
  const o = Number(props.adjust?.opacity);
  return Number.isFinite(o) ? Math.max(0.05, Math.min(1, o)) : 1;
});
const scale = computed(() => Number(props.adjust?.scale) > 0 ? Number(props.adjust.scale) : 100);
const x = computed(() => (Number.isFinite(Number(props.adjust?.x)) ? Number(props.adjust.x) : 50));
const y = computed(() => (Number.isFinite(Number(props.adjust?.y)) ? Number(props.adjust.y) : 50));
</script>
